import React from 'react';
import {
  MuiPickersUtilsProvider,
  DatePickerProps,
  KeyboardDatePicker,
} from '@material-ui/pickers';
import MomentUtils from '@date-io/moment';
import moment from 'moment';

const CustomDatePicker: React.FC<DatePickerProps> = ({ ...props }) => {
  return (
    <MuiPickersUtilsProvider libInstance={moment} utils={MomentUtils}>
      <KeyboardDatePicker
        autoOk
        fullWidth
        variant="inline"
        inputVariant="outlined"
        invalidDateMessage="Data em formato inválido."
        placeholder="Ex.: 01/01/2021"
        format="DD/MM/YYYY"
        {...props}
      />
    </MuiPickersUtilsProvider>
  );
};

export default CustomDatePicker;
